import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { PageHeaderComponent } from '../page-header/page-header.component';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { SuccessFailureMessageComponent } from '../alert-message/success-failure-message.component';
import { CardsComponent } from '../cards/cards.component';
import { PopoverComponent } from '../popover/popover.component';
import { FusionButtonComponent } from '../fusion-button/fusion-button.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { EssComponent } from 'src/app/pages/ess/ess.component';
import { Subscription } from 'rxjs';
import { Constants } from 'src/app/models/Constants';
import { ApiService } from 'src/app/services/api.service';
import { SideNavEmitService } from 'src/app/services/side-nav-emit.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/services/alert.service';
import { GlobalValuesService } from 'src/app/services/global-values.service';
import { HttpErrorResponse, HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-time-management',
  standalone: true,
  templateUrl: './time-management.component.html',
  styleUrls: ['./time-management.component.css'],
  imports: [CommonModule, PageHeaderComponent, FormsModule, ReactiveFormsModule, SuccessFailureMessageComponent,CardsComponent,PopoverComponent,FusionButtonComponent,AngularSvgIconModule,
    EssComponent]
})
export class TimeManagementComponent implements OnInit {
  isHamClicked:boolean = false;

  essTabToShow: string = 'details';
  pageComponentName = 'Ess';

  hideOrShowNav: string = "side-nav-container";
  documentsForm! : FormGroup;
  timeSettingForm! : FormGroup;
  numberRegex = "^[0-9]*$";
  mobileRgx = "^([0-9]{4,16})"; // Added this for text Validation and used them further down the lines
  textRegex = "^[a-zA-Z ]*$"; // Added this for text Validation and used them further down the lines
  errorMessage = '';
  showSubmissionMsg = false;
  showDeletedMsg = false;
  showErrorMsg = false;
  bankGetData:any;
  isDevMode: boolean = false;
  employeeId:any;
  @Input() selectedUser:any;
  @Input() employeeFinanceInfo : any;
  @Input() fromSettings  = false; //SK26JUL24 bank info from settings
  fromHrmPage = false;
  successMsg = Constants.SUCCESS_MESSAGE;
  deletedMsg = Constants.DELETE_SUCCESS_MESSAGE;
  companyId = this.globalValues.orgId;
  settingsData: any;

  constructor(private formBuilder: FormBuilder, private apiService: ApiService,private sideNavItem: SideNavEmitService, private errorHandler: ErrorHandlerService, private router: Router, private alertService: AlertService, private globalValues: GlobalValuesService) 
  {

      this.timeSettingForm = this.formBuilder.group({
      'startTime' : ['', Validators.required],
      'endTime' : ['', Validators.required],
      'CheckIn' : ['', Validators.required],
      'CheckOut' : ['', Validators.required],
      'workingHours' :['', [Validators.required, Validators.min(0), Validators.max(12)]]
      }) 
      const settingsDataString = localStorage.getItem('settingsData');
      this.settingsData = settingsDataString ? JSON.parse(settingsDataString) : null;
  }

  ngOnInit(): void {
    
  }

  errorMsg(err: HttpErrorResponse){
    this.errorHandler.handleError(err);
    this.errorMessage = this.errorHandler.errorMessage;
    this.alertService.messageOnPass('error', this.errorMessage);
  }

  setData(){
    const value = this.timeSettingForm.value;
      this.apiService.writeValue('patch', '/settings/time', {employeeWorkTime:{'startTime': value.startTime, 'endTime': value.endTime}, graceHours:{'checkIn': value.CheckIn, 'checkOut': value.CheckOut}, 'workingHours': value.workingHours}) //SK25JUL24
      .subscribe({
        next: (data:any) => {
          this.alertService.messageOnPass('success', 'Data saved successfully');
          this.alertService.messageOnPass('success', this.successMsg);
          this.apiService.fetchData( '/user')
              .subscribe({
              next: (data) => {
                localStorage.setItem('settingsData', JSON.stringify(data.settings[0]))
                const settingsDataString = localStorage.getItem('settingsData');
                this.settingsData = settingsDataString ? JSON.parse(settingsDataString) : null;
              },
              error: (err: HttpErrorResponse) => {
                this.errorMsg(err);
              }
            });
        },
        error: (err: HttpErrorResponse) => {
          this.errorMsg(err);
        }
      });
  }

  setDatas(){
    this.timeSettingForm = this.formBuilder.group({
      'startTime': [this.settingsData?.employeeWorkTime?.startTime, Validators.required],
      'endTime': [this.settingsData?.employeeWorkTime?.endTime, Validators.required],
      'CheckIn': [this.settingsData?.graceHours?.checkIn, Validators.required],
      'CheckOut': [this.settingsData?.graceHours?.checkOut,Validators.required],
      'workingHours': [this.settingsData?.workingHours, [Validators.required, Validators.min(0), Validators.max(12)]],
    });
  }
}
